import { h } from 'preact';
import { getReturnUrl, isSearchResultView } from '../../lib/Utils';
import {
  getCurrentRouteName,
  getPreviousRouteName,
  isGlobalReviewRoute,
  NAME as ROUTE_NAME,
  shouldShowLightThemeOnRoute
} from '../../lib/Route';
import {
  awayFromCartNativeHandler,
  onClearCartNativeHandler
} from '../../../../../nativeConnectors/platform';
import { getOrder } from '../../lib/Order';
import { getCatalogueTheme } from '../../lib/Amalgam';
import BackIcon from '../Icon/BackIcon';
import './styles.less';

const BackButton = ({ className, goBack, showBackIcon = true, showBackForSingleCatalogue }) => {
  const currentRoute = getCurrentRouteName();

  const shouldShowBack = () => {
    const previousRoute = getPreviousRouteName();
    if (
      (currentRoute === ROUTE_NAME.GALLERY ||
        currentRoute === ROUTE_NAME.RESELLER_CATALOGUE_GALLERY ||
        currentRoute === ROUTE_NAME.GLOBAL_REVIEW ||
        currentRoute === ROUTE_NAME.RESELLER_GLOBAL_REVIEW ||
        currentRoute === ROUTE_NAME.CUSTOMER_ORDERS ||
        currentRoute === ROUTE_NAME.ERROR ||
        (currentRoute === ROUTE_NAME.CUSTOM_PAGE && window.location.pathname) ||
        ((currentRoute === ROUTE_NAME.GROUP || currentRoute === ROUTE_NAME.CUSTOM_PAGE) &&
          (previousRoute === ROUTE_NAME.CUSTOM_PAGE || previousRoute === ROUTE_NAME.GROUP)) ||
        (currentRoute === ROUTE_NAME.HOME && showBackForSingleCatalogue)) &&
      typeof goBack === 'function'
    ) {
      return true;
    }
    return isSearchResultView();
  };

  if (!showBackIcon || !shouldShowBack()) {
    return;
  }

  const { backIconColor, themeTextColor } = getCatalogueTheme();

  const iconColor = shouldShowLightThemeOnRoute(currentRoute) ? themeTextColor : backIconColor;

  const goBackWithFallBackUrl = (fallbackUrl) => {
    fallbackUrl = fallbackUrl || '/';
    const prevPage = window.location.href;
    window.history.go(-1);
    setTimeout(() => {
      if (window.location.href === prevPage) {
        window.location.href = fallbackUrl;
      }
    }, 100);
  };

  const onBackClick = () => {
    if (isSearchResultView()) {
      goBackWithFallBackUrl(getReturnUrl());
      return;
    }
    if (typeof goBack === 'function') {
      if (isGlobalReviewRoute(currentRoute)) {
        awayFromCartNativeHandler(location.href);
        getOrder().then((order) => {
          if (!order) {
            onClearCartNativeHandler(location.href);
          }
        });
      }
      goBack();
    }
  };

  return (
    <BackIcon className={`back-icon ${className || ''}`} color={iconColor} onClick={onBackClick} />
  );
};

export default BackButton;
